export function calculatePaginationIndices(args) {
  const { total, per_page = 10, current_page } = args;
  const totalPage = Math.ceil(total / per_page);

  return {
    totalPage,
    totalItems: total,
    currentPage: current_page - 1,
    perPage: per_page,
  };
}
